import React from 'react';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Content from '../../components/Content';

function Landing(): React.ReactElement {
  return (
    <>
      <Header />
      <Content />
      <Footer />
    </>
  );
}

export default Landing;
